import type { TranslationKey } from "@/i18n";

/**
 * The two places the classroom pages are mounted. Teachers reach their own classrooms live from
 * MyBestUser; admins reach every synced classroom. Both can assign and delete homework.
 */
export type ClassroomScope = "teacher" | "admin";

export const CLASSROOM_ROOT = {
  teacher: "/teacher/classrooms",
  admin: "/admin/classrooms",
} as const;

/** Where leaving a classroom leads: teachers to their own list, admins to the schools above it. */
export const CLASSROOM_INDEX = {
  teacher: { to: "/teacher/classrooms", labelKey: "nav.classrooms" },
  admin: { to: "/admin/schools", labelKey: "nav.schools" },
} as const satisfies Record<ClassroomScope, { to: string; labelKey: TranslationKey }>;
